import { createStore, applyMiddleware, compose } from 'redux';
import * as Reducers from '../reducers/Reducers';
import thunkMiddleware from 'redux-thunk';

export function reactStartupStore(formConfig: object, formDefinitions: object) {

    let store : any;
    const isDevelopment = (process.env.NODE_ENV !== 'production');

    if ( isDevelopment && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ !== undefined) {
          
        const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
        const enhancer = composeEnhancers(applyMiddleware(thunkMiddleware));

        store = createStore(Reducers.default, enhancer);
    } else {
        store = createStore(Reducers.default, applyMiddleware(thunkMiddleware));
    }

    return store;
}